import { typedDoc, getDocument, setDocument } from '@/lib/firebase/firestore'
import { createUserFacingError } from '@/lib/errors'
import type { CompanyMemberDocument } from '@/types'

const ALLOWED_FIELDS = ['bio', 'photoUrl', 'squarePhotoUrl', 'portraitPhotoUrl', 'socialLinks'] as const
export type SelfEditableMemberFields = Pick<
  CompanyMemberDocument,
  (typeof ALLOWED_FIELDS)[number]
>

export const memberProfileService = {
  async get(memberId: string): Promise<CompanyMemberDocument | null> {
    const ref = typedDoc<CompanyMemberDocument>('company', memberId)
    return getDocument(ref)
  },

  async update(memberId: string, patch: Partial<SelfEditableMemberFields>): Promise<void> {
    const ref = typedDoc<CompanyMemberDocument>('company', memberId)
    const existing = await getDocument(ref)
    if (!existing) throw createUserFacingError('Your member profile could not be found.')
    const filtered: Partial<SelfEditableMemberFields> = {}
    for (const key of ALLOWED_FIELDS) {
      if (key in patch) (filtered as Record<string, unknown>)[key] = patch[key]
    }
    await setDocument(ref, { ...existing, ...filtered } as unknown as CompanyMemberDocument)
  },
}
